module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrapper page-leaderboard animate fadeIn"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("ยอดบริจาค")]), _vm._v(" "), _c('div', {
    staticClass: "container-leaderboard"
  }, [_c('ul', {
    staticClass: "tab"
  }, [_c('li', {
    staticClass: "tab-page"
  }, [_c('a', {
    class: {
      active: _vm.activeTab === 'page'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.switchTab('page')
      }
    }
  }, [_c('span', {
    staticClass: "icon _sl-page"
  }, [_vm._v(" ")]), _vm._v("กองผ้าป่า")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-school"
  }, [_c('a', {
    class: {
      active: _vm.activeTab === 'school'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.switchTab('school')
      }
    }
  }, [_c('span', {
    staticClass: "icon _sl-school"
  }, [_vm._v(" ")]), _vm._v("โรงเรียน")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-province"
  }, [_c('a', {
    class: {
      active: _vm.activeTab === 'province'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.switchTab('province')
      }
    }
  }, [_c('span', {
    staticClass: "icon _sl-province"
  }, [_vm._v(" ")]), _vm._v("จังหวัด")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('product-leaderboard', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'page'),
      expression: "activeTab === 'page'"
    }],
    ref: "page",
    attrs: {
      "link": true,
      "searchable": true
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('product-leaderboard', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'school'),
      expression: "activeTab === 'school'"
    }],
    ref: "school",
    attrs: {
      "type": "categories",
      "title-field": "name",
      "params": {
        with_total: true,
        vocab: 'school'
      },
      "ipp": 100,
      "load-on-start": false
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('product-leaderboard', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'province'),
      expression: "activeTab === 'province'"
    }],
    ref: "province",
    attrs: {
      "type": "categories",
      "title-field": "name",
      "params": {
        with_total: true,
        vocab: 'province'
      },
      "load-on-start": false,
      "ipp": 100
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a14c904","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductLeaderboardPage.vue
// module id = 1103
// module chunks = 1